

const NotFound = () => {
    return(
        <div>
            <h3>Данная страница находится в разработке</h3>
        </div>
    );
}
export default NotFound;